import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import { Session } from '../business-objects/session/session.model';

export class SessionFacade {

    protected hasBooted: boolean = false;
    sessionBeforeBoot$ = new Subject<Session>();

    constructor(protected appFacade: VasAppFacade) {

    }

    boot(): void {

        if (this.hasBooted) {
            throw new Error('session has already been booted');
        }

        this.hasBooted = true;
        this._getSession().subscribe(session => {
            this.sessionBeforeBoot$.next(session);
        });
    }

    getSession(): Observable<Session> {
        return !this.hasBooted ? this.sessionBeforeBoot$ : this._getSession();
    }

    _getSession(): Observable<Session> {
        return Observable.combineLatest(
            this.appFacade.getActiveUser(),
            this.appFacade.network.getNetworkStatus()
        )
            .map(args => new Session(args[0], args[1]));
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/session-facade.ts